import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import Logo from "../components/Logo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
  color: #ff734f;
`;

const Message = styled.p`
  margin-bottom: 2rem;
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 600px;
`;

const HomeLink = styled(Link)`
  color: #ff734f;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const SuccessPage: React.FC = () => {
  const location = useLocation();
  const { theme, email } = location.state || {};

  return (
    <Container>
      <Logo />
      <Title>Inscription confirmée !</Title>
      <Message>
        Votre inscription à la newsletter sur "{theme}" a bien été prise en
        compte. Vous recevrez bientôt un email de confirmation à l'adresse{" "}
        {email}.
      </Message>
      <HomeLink to="/">Retour à l'accueil</HomeLink>
    </Container>
  );
};

export default SuccessPage;
